// @packages
import React, { useEffect, useState } from 'react';
import {
  Text,
  View
} from 'react-native';
import { ListItem } from '@rneui/themed';

// @scripts
import dayjs from 'dayjs';
import useStyles from './styles';
import { ISession } from '../../../utils/types';
import { config } from '../../../core/config';

type Props = {
  sessionsFormatted: ISession[]
};

const ScheduleItem = ({
  sessionsFormatted
}: Props) => {
  const styles = useStyles();

  const [sessions, setSessions] = useState<ISession[]>([]);

  const getSessions = () => {
    if (sessionsFormatted.length) {
      const filteredAndSortedSessions = sessionsFormatted
        .filter((s) => dayjs().isSameOrBefore(s.end))
        .sort((a, b) => Number(
          dayjs(a.start).valueOf() - dayjs(b.start).valueOf()
        ));

      setSessions(filteredAndSortedSessions);
    }
  };

  useEffect(() => {
    getSessions();
  }, [sessionsFormatted]);

  return (
    <View>
      {
        sessions.length
          ? sessions.map((session) => (
            <ListItem key={session.id}>
              <ListItem.Content style={styles.firstColumn}>
                <ListItem.Title style={styles.itemText}>
                  {session.name}
                </ListItem.Title>
              </ListItem.Content>
              <ListItem.Content style={styles.secondColumn}>
                <ListItem.Title style={styles.itemText}>
                  {dayjs(session.start)
                    .format('MM/DD/YY @ HH:mm A')}
                </ListItem.Title>
              </ListItem.Content>
              <ListItem.Content style={styles.secondColumn}>
                <ListItem.Title style={styles.itemText}>
                  {dayjs(session.end)
                    .format('MM/DD/YY @ HH:mm A')}
                </ListItem.Title>
              </ListItem.Content>
            </ListItem>
          ))
          : <Text style={styles.time}>{config.text.siteScheduleDetail.noSessionFound}</Text>
      }
    </View>
  );
};

export default ScheduleItem;
